import { FC } from 'react';
import { IQuestionConfig } from '../core/IQuestion';
import { IGenericQuestionProvider, IQuestionViewProps } from '../core/question-provider/IQuestionProvider';
import { MiniWizardViewModel } from '../core/MiniWizardViewModel';
import { Step } from '../../Step';
import { IonButton } from '@ionic/react';

const questionType = 'survey' as const;
type IQuestionType = typeof questionType;

type ISurveyQuestionProps = {
    options: string[];
 };

export type ISurveryQuestionAnswers = [];

export type ISurveyQuestion = IQuestionConfig<IQuestionType, ISurveryQuestionAnswers, ISurveyQuestionProps >;

export class SurveyQuestionProvider implements IGenericQuestionProvider<ISurveyQuestion> {
    questionType = questionType;

    validate = (question: ISurveyQuestion) => Boolean(question.answer?.length);

    render = (question: ISurveyQuestion, wizard: MiniWizardViewModel) => {
        return <SurveyQuestionView question={question} wizard={wizard} />;
    };
}

export const SurveyQuestionView: FC<IQuestionViewProps<ISurveyQuestion>> = ({ question, wizard }) => {
    const answers = new Set((question.answer as string[]));

    const onOptionClick = (opt: string) => {
        answers.delete(opt) || answers.add(opt);
        wizard.answer(Array.from(answers)); // convert Set to array
    };

    return (
        <Step
            question={question.questionTitle}
            subTitle={question.subTitle}
        >
            {question.options.map((opt) => {
                const fill: 'outline' | 'solid' = answers.has(opt) ? 'solid' : 'outline';
                return (
                    <div key={opt} style={{ width: '90%', marginLeft: 'auto', marginRight: 'auto' }}>
                        <IonButton
                            fill={fill}
                            data-id={opt}
                            className="ion-text-wrap"
                            onClick={() => onOptionClick(opt)}
                            style={{width: '100%', marginBottom: 10, minHeight: 48}}
                        >{opt}</IonButton>
                    </div>
                );
            })}
        </Step>
    );
};

